import store from '@js/store'

export default [
    {
        path: 'transactions',
        name: 'appUtilityTransaction',
        redirect: { name: 'appUtilityTransactionList' },
        meta: { 
            title: 'utility.transaction.transactions', 
            icon: 'fas fa-money-check',
            hideChildren: true,
            isNotNav: false,
            permissions: ['access-transaction']
        },
        beforeEnter: ((to, from, next) => {
            if( 0 && !store.getters['config/configs'].system.transaction) {
                next({ name: 'appDashboard'})
            } else {
                next()
            }
        }),
        component: {
            template: '<router-view></router-view>'
        },
        children: [
            {
                path: '',
                name: 'appUtilityTransactionList',
                meta: { 
                    trans: 'global.list',
                    title: 'utility.transaction.transactions',
                },
                component: () => store.getters['user/roles']=='admin'?import('@views/app/utility/transaction/index'):import('@views/app/utility/transaction/index_user') /* webpackChunkName: "js/app/utility/transaction/index" */
            },
            {
                path: 'add',
                name: 'appUtilityTransactionAdd',
                meta: { 
                    trans: 'global.add',
                    title: 'utility.transaction.transaction',
                    permissions: ['access-config']
                },
                component: () => import('@views/app/utility/transaction/add' /* webpackChunkName: "js/app/utility/transaction/add" */),
            },
            {
                path: ':uuid/edit',
                name: 'appUtilityTransactionEdit',
                meta: { 
                    trans: 'global.edit',
                    title: 'utility.transaction.transaction',
                },
                component: () => import('@views/app/utility/transaction/edit' /* webpackChunkName: "js/app/utility/transaction/edit" */),
            },            
            {
                path: ':uuid',
                name: 'appUtilityTransactionView',
                meta: { 
                    trans: 'global.view',
                    title: 'utility.transaction.transaction',
                },
                component: () => import('@views/app/utility/transaction/view' /* webpackChunkName: "js/app/utility/transaction/view" */),
            }
        ]
    },
]